import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'fgb-auction-detail-page',
  templateUrl: './auction-detail-page.component.html',
  styleUrls: ['./auction-detail-page.component.scss'],
})
export class AuctionDetailPageComponent implements OnInit {
  constructor(private route: ActivatedRoute, private location: Location) {}

  id: number;
  backLink: string = '/rewards/marketplace';

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
  }

  goBack() {
    this.location.back();
  }
}
